import { useEffect, useState } from "react";
import { useTime } from "../pages/countdown/Countdown";

/* Original logo
<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="14" cy="14" r="14" fill="#40A949"/>
<path d="M14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24Z" stroke="black" stroke-width="2"/>
<path d="M14 14V8" stroke="black" stroke-width="2" stroke-linecap="round"/>
<path d="M14 14H18" stroke="black" stroke-width="2" stroke-linecap="round"/>
</svg>
*/

export default function Clock({ size = 200, className = "", style }: { size?: number, className?: string, style?: React.CSSProperties }) {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    const time = useTime();
    const date = new Date(time);

    const hours = isMounted ? date.getHours() : 12;
    const minutes = isMounted ? date.getMinutes() : 0;
    const seconds = isMounted ? date.getSeconds() : 0;

    const secondsAngle = seconds * 6;
    const minutesAngle = minutes * 6 + seconds * 0.1;
    const hoursAngle = (hours % 12) * 30 + minutes * 0.5;

    return <svg
        style={style}
        className={className}
        width={size}
        height={size}
        viewBox="0 0 28 28"
    >
        <circle cx="14" cy="14" r="14" fill="#40A949" />
        <circle cx="14" cy="14" r="10" fill="transparent" stroke="black" strokeWidth="2" />
        <line
            x1={14} y1={14}
            x2={14 + 4 * Math.sin(hoursAngle * Math.PI / 180)}
            y2={14 - 4 * Math.cos(hoursAngle * Math.PI / 180)}
            stroke="black" strokeWidth="2" strokeLinecap="round"
        />
        <line
            x1={14} y1={14}
            x2={14 + 6 * Math.sin(minutesAngle * Math.PI / 180)}
            y2={14 - 6 * Math.cos(minutesAngle * Math.PI / 180)}
            stroke="black" strokeWidth="2" strokeLinecap="round"
        />
        <line
            x1={14} y1={14}
            x2={14 + 7 * Math.sin(secondsAngle * Math.PI / 180)}
            y2={14 - 7 * Math.cos(secondsAngle * Math.PI / 180)}
            stroke="black" strokeWidth={1} strokeLinecap="round" opacity={0.5}
        />
    </svg>;
}